import { useParams, Link } from 'react-router-dom';
import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import SchemaOrg from '@/components/feature/SchemaOrg';
import { categories, Movie, getMoviesByCategory } from '@/mocks/movies';

export default function Category() {
  const { slug } = useParams<{ slug: string }>();
  const currentCategory = categories.find((c) => c.slug === slug);
  const movies: Movie[] = slug ? getMoviesByCategory(slug) : [];

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [slug]);

  const categoryName = currentCategory?.name || slug || '';

  return (
    <div className="min-h-screen bg-background-50">
      <SchemaOrg
        type="WebPage"
        data={{
          name: `${categoryName} - 成全影院`,
          description: `成全影院${categoryName}频道，汇集最新最全的${categoryName}资源，高清画质流畅播放，无广告干扰免费在线观看。`,
          url: `https://chengquan.tv/category/${slug}`,
        }}
      />

      <Navbar />
      <main className="pt-16">
        <div className="bg-background-100 border-b border-background-200/70">
          <div className="max-w-[1280px] mx-auto">
            <Breadcrumb
              items={[
                { label: '首页', href: '/' },
                { label: '分类浏览', href: '/category/dongzuo' },
                { label: categoryName },
              ]}
            />
          </div>
        </div>

        <section className="w-full px-4 md:px-6 py-10">
          <div className="max-w-[1280px] mx-auto">
            <div className="mb-8">
              <h1 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
                {categoryName}
              </h1>
              <p className="text-sm text-secondary-500 mt-2">
                共 {movies.length} 部影片
              </p>
            </div>

            <div className="flex flex-wrap gap-2 mb-8">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                  className={`flex items-center gap-1.5 px-4 py-2 rounded-full text-sm whitespace-nowrap transition-all ${
                    cat.slug === slug
                      ? 'bg-primary-500 text-background-50'
                      : 'bg-background-100 text-foreground-700 hover:bg-primary-100 hover:text-primary-600'
                  }`}
                >
                  <i className={`${cat.icon} text-xs`}></i>
                  {cat.name}
                </Link>
              ))}
            </div>

            {movies.length > 0 ? (
              <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 md:gap-5" data-product-shop="">
                {movies.map((movie) => (
                  <Link
                    key={movie.id}
                    to={`/category/${movie.category}`}
                    className="group block"
                    onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                  >
                    <div className="relative aspect-[2/3] rounded-lg overflow-hidden mb-3 bg-secondary-100">
                      <img
                        src={movie.image}
                        alt={movie.title}
                        title={`${movie.title} - 成全影院高清在线观看`}
                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                        loading="lazy"
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                      <div className="absolute top-2 right-2 bg-primary-500 text-background-50 text-xs font-bold px-2 py-1 rounded-md whitespace-nowrap">
                        {movie.rating}
                      </div>
                    </div>
                    <h3 className="text-sm font-medium text-foreground-900 group-hover:text-primary-500 transition-colors truncate">
                      {movie.title}
                    </h3>
                    <div className="flex items-center gap-2 mt-1">
                      <span className="text-xs text-secondary-400 whitespace-nowrap">{movie.year}</span>
                      <span className="text-xs px-2 py-0.5 bg-accent-100 text-accent-700 rounded-full whitespace-nowrap">
                        {categoryName}
                      </span>
                    </div>
                  </Link>
                ))}
              </div>
            ) : (
              <div className="text-center py-20">
                <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center bg-background-100 rounded-full">
                  <i className="ri-movie-line text-2xl text-secondary-400"></i>
                </div>
                <p className="text-secondary-500">该分类暂无影片</p>
              </div>
            )}
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}